import type { SVGProps } from "react";

export function IconVideoSeekForward(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      stroke="white"
      strokeWidth="1.8"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video seek forward ten seconds</title>
      <path
        d="M24 8 A16 16 0 1 0 40 24"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="19,3 24,8 19,13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text
        dominantBaseline="middle"
        fill="white"
        fontFamily="Inter, sans-serif"
        fontSize="13"
        fontWeight="500"
        stroke="none"
        textAnchor="middle"
        x="24"
        y="26"
      >
        10
      </text>
    </svg>
  );
}
